import { jianlaiDictums } from "./jianlaiDictums";
import xuezhongDictums from "./xuezhongDictum";

// 剑来数据源 - 烽火戏诸侯作品《剑来》中的经典语录
export type dictumsType = Array<
  | string
  | {
    dictum: string;
    origin?: string;
  }
>;

export const dictums2: dictumsType = [
  {
    dictum: '做不到的事情别随意承诺。',
    origin: '《地狱少女》',
  },
  {
    dictum: '我可能比想象中还要喜欢你',
    origin: '樱岛麻衣《青春猪头少年不会梦到兔女郎学姐》',
  },
  {
    dictum: '我愿维系着世界静谧的光。',
    origin: '咕啾组《加油大魔王》',
  },
  {
    dictum: '我们风雨兼程绝不空手而归',
  },
  {
    dictum: '过去无可挽回，未来可以改变。',
    origin: '《一人之下》',
  },
  {
    dictum: '须知少时凌云志，曾许人间第一流。',
    origin: '吴庆坻《悔余生诗》',
  },
  {
    dictum: '劝君莫惜金缕衣，劝君惜取少年时。',
    origin: '无名氏《金缕衣》',
  },
  {
    dictum: '“神明是存在的，但神并不爱你。”',
    origin: '《文豪野犬》',
  },
  {
    dictum: '关关难过关关过，前路漫漫亦灿灿。',
  },
  {
    dictum: '我不知道将去何方，但我已在路上。',
    origin: '宫崎骏《千与千寻》',
  },
  {
    dictum: '你早起，我早起，我们迟早在一起。',
  },
  {
    dictum: '生命可以随心所欲，但不能随波逐流。',
    origin: '《猫的报恩》',
  },
  {
    dictum: '告诉桃花不用开了，我等的人他来了。',
  },
  {
    dictum: '愿少年，乘风破浪，他日毋忘化雨功。',
    origin: '汪曾祺',
  },
  {
    dictum: '不要对外表过分在意，心灵才是最重要的',
    origin: '宫崎骏《魔女宅急便》',
  },
  {
    dictum: '你是年少的欢喜，这句话反过来也是你。',
    origin: '《最好的我们》',
  },
  {
    dictum: '我做不到的由你来，你做不到的由我来。',
    origin: '山治《海贼王》',
  },
  {
    dictum: '你是我绕过山河错落，才找到的人间烟火。',
  },
  {
    dictum: '我拼命追赶那道光，因为光的尽头有你在。',
    origin: '新海诚《天气之子》',
  },
  {
    dictum: '我们仰望同一片天空，却看着不同的地方。',
    origin: '《秒速五厘米》',
  },
  {
    dictum: '感谢你精彩耀眼， 做我平淡岁月里的星辰。',
  },
  {
    dictum: '我早就发现，我和她，不仅仅是青梅竹马了。',
    origin: '工藤新一〈名侦探柯南〉',
  },
  {
    dictum: '我希望他永远发光，而我永远为他热泪盈眶。',
  },
  {
    dictum: '山河远阔，人间烟火，无一是你，无一不是你。',
    origin: '春和《江海共余生》',
  },
  {
    dictum: '我们总是在意错过太多，却不注意自己拥有多少。',
    origin: '《未闻花名》',
  },
  {
    dictum: '如果结果不如你所愿 就在尘埃落定前奋力一搏。',
    origin: '夏目贵志',
  },
  {
    dictum: '如果结果并非所愿，那就在尘埃落定前奋力一搏。',
    origin: '绿川幸《夏目友人帐》',
  },
  {
    dictum: '越是华丽美艳让人心悸， 消失时就越觉得寂寞。',
    origin: '《ReLIFE》',
  },
  {
    dictum: '有一种东西不能遵循从众原则，那就是人的良心。',
    origin: '《杀死一只知更鸟》',
  },
  {
    dictum: '当你无法再拥有时，你唯一能做的就是不要再忘记。',
    origin: '《龙猫》',
  },
  {
    dictum: '按照自己的喜好去做，得不到别人的赞赏也没关系。',
    origin: '贝尔梅丽《海贼王》',
  },
  {
    dictum: '善良本就是一种牺牲，自愿牺牲，或着被人牺牲……',
    origin: '丁果《妙先生》',
  },
  {
    dictum: '孤独的人不会伤害别人，只会不断地伤害自己罢了。',
    origin: '大老师《我的青春恋爱物语果然有问题》',
  },
  {
    dictum: '只有那些勇敢镇定的人，才能熬过黑暗，迎来光明。',
    origin: '安赫尔·阿斯图',
  },
  {
    dictum: '世人就是这样，以为道歉，那些伤害就不复存在了……',
    origin: '丁果《妙先生》',
  },
  {
    dictum: '我跟她约好了，夺取世界上所有能力，然后回到她身边',
    origin: '乙坂有宇《Charlotte(夏洛特)》',
  },
  {
    dictum: '散落在你眼角的那片雪花，是我对你说的新年快乐啊。',
    origin: '子雾啊',
  },
  {
    dictum: '是达令把我带到这里的哦，我第一次看到能游泳的大海',
    origin: '02《DARLING in the FRANXX》',
  },
  {
    dictum: '“人生最重要的是时机，时机对了，凡事都有可能。”',
    origin: '《深夜食堂》',
  },
  {
    dictum: '“无论过去，不问将来.” “死亡是无法跨越的节点.',
    origin: '《时光代理人》',
  },
  {
    dictum: '拥有希望的人，和漫天的星星一样，是永远不会孤独的。',
    origin: '《星游记》',
  },
  {
    dictum: '所谓影子，无论怎样黯淡，没有光就无法在地面上成形。',
    origin: '《银魂》',
  },
  {
    dictum: '没有什么是完美的，这个世界并不完美，所以才显得美丽.',
    origin: '《钢之炼金术师》',
  },
  {
    dictum: '日子总要往前走的，人总是在变，不知道是淡忘还是适应。',
    origin: '巫哲《撒野》',
  },
  {
    dictum: '与其在意别人的背弃和不善，不如经营自己的尊严和美好。',
    origin: '可可・香奈儿',
  },
  {
    dictum: '温柔正确的人总是难以生存，因为这世界既不温柔，也不正确',
    origin: '大老师《我的青春恋爱物语果然有问题》',
  },
  {
    dictum: '我再也不要看见她哭的样子了，就算我从此从她心目中消失。',
    origin: '工藤新一〈名侦探柯南〉',
  },
  {
    dictum: '可能我们的世界很单纯，单纯的用一次表白就能让它焕然一新',
    origin: '双叶理央《青春猪头少年不会梦到兔女郎学姐》',
  },
  {
    dictum: '你的名字那么好听，一定要出现在心仪学校的录取通知书上啊！',
  },
  {
    dictum: '如果说真实是残酷的，谎言绝对是温柔的吧。所以，温柔是谎言。',
    origin: '《我的青春恋爱物语果然有问题》',
  },
  {
    dictum: '如果不能成长为一颗参天大树，那就把它种在风平浪静的花园中…',
    origin: '《星辰变》',
  },
  {
    dictum: '不要停止奔跑，不要回顾来路，来路无可眷恋，值得期待的只有前方。',
    origin: '《马男波杰克》',
  },
  {
    dictum: '“确实他们是虚构的，但在我们的记忆中，他们一直存在着，直到永远”',
  },
  {
    dictum: '正因为他的陪伴，给予我莫大的救赎。可是我却连一句感谢都没来得及说',
    origin: '乙坂隼翼《Charlotte(夏洛特)》',
  },
  {
    dictum: '谁终将声震人间，必长久深自缄默。谁终将点燃闪电，必长久如云漂泊。',
    origin: '尼采',
  },
  {
    dictum: '抗命不可能，顺命太轻闲，遵命得认真，唯有乐命，乐命最是自由自在。',
    origin: '三毛',
  },
  {
    dictum: '也许世界上也有五千多和你一模一样的花，但只有你是我独一无二的玫瑰。',
    origin: '《小王子》',
  },
  {
    dictum: '人不应该根据背负的罪孽而选择道路，而是应当在选择的道路上背负罪孽。',
    origin: '《空之境界》',
  },
  {
    dictum: '逃避有两种：我们把有目的的逃避叫做飞翔，把没有目的的逃避叫做漂浮。',
    origin: '苍崎橙子《空之境界》',
  },
  {
    dictum: '世界上没有一成不变的事物，所以只要以其他方式找到自己的快乐就行了。',
    origin: '冈崎朋也《Clannad》',
  },
  {
    dictum: '发生的事情就无法挽回、 后悔是没有意义的，失去的东西已经无法挽回了。',
    origin: '《地狱少女》',
  },
  {
    dictum: '所谓“大家”，就是无视并牺牲了一部分弱势群体后所达到的虚伪的和平与共识',
    origin: '《我的青春恋爱物语果然有问题》',
  },
  {
    dictum: '暴躁的人其实挺容易哄,反倒那些看似永远没脾气的人,一旦离开就无影无踪了。',
    origin: '《怦然心动》',
  },
  {
    dictum: '不管你扔几次骰子想要重来，人心都是不会变的 假话不能成为真相，事实无法变做谎言',
    origin: '梓川咲太《青春猪头少年不会梦到兔女郎学姐》',
  },
  {
    dictum: '日出未必意味着光明，太阳也无非是颗辰星而已，只有在我们醒着时，才是真正的破晓。',
    origin: '梭罗《瓦尔登湖》',
  },
  {
    dictum: '趁着年轻， 跌倒了还能爬起来， 多吸取教训， 学会重新站起来的方法也是很重要的。',
    origin: '《ReLIFE》',
  },
  {
    dictum: '在所谓的人世间摸爬滚打至今，我唯一愿意视为真理的就只有这一句话：一切都会过去的。',
    origin: '太宰治',
  },
  {
    dictum: '不管前方的路有多苦，只要走的方向正确，不管多么崎岖不平，都比站在原地更接近幸福。',
    origin: '宫崎骏《千与千寻》',
  },
  {
    dictum: '一个人至少拥有一个梦想，有一个理由去坚强。心若没有栖息的地方，到哪里都是在流浪。',
    origin: '三毛《我的青春谁做主》',
  },
  {
    dictum: '到不了的地方都叫做远方，回不去的世界都叫做家乡，我一直向往的却是比远方更远的地方。',
    origin: '《幽灵公主》',
  },
  {
    dictum: '如果你停止，就是谷底。如果你还在继续，就是上坡。这是我听过关于人生低谷最好的阐述。',
    origin: '刘同《你的孤独，虽败犹荣》',
  },
  {
    dictum: '广：02，今后希望你能把想到的东西都告诉我 02：嗯，为什么 广：因为我想更了解02',
    origin: '《DARLING in the FRANXX》',
  },
  {
    dictum: '世间所有相遇本就是久别重逢，只要记住你的名字，不管你在世界的哪个地方，我一定去见你。',
    origin: '新海诚《你的名字》',
  },
  {
    dictum:
      '活着，是一件很美好的事情。既然来到人间，便去爱，去经历，去感受，去欣赏一切微小的欢喜。',
    origin: '《一禅小和尚》',
  },
  {
    dictum:
      '当你犹豫要不要去做一件事的时候，其实你内心已经有了选择，只是你还没有充足的理由去说服自己。',
    origin: '东野圭吾',
  },
  {
    dictum:
      '我见过春日下风，秋叶冬雪，也踏遍南水北山，东麓西岭，可这四季春秋沧山泱水，都不及你冲我展眉一笑。',
    origin: '《网易云热评》',
  },
  {
    dictum:
      '人生总是奇妙的，一旦你努力去做一件事，如果结果不是你想象的那样，那么老天一定会给你一个更好的结果。',
    origin: '刘同',
  },
  {
    dictum:
      '若今生长剑浣花，生死无涯。便许你来世雪底封刀，结庐为家。 你可愿荆钗绾发，为我煮茶，明朝江湖饮马。',
    origin: '《秦时明月》',
  },
  {
    dictum:
      '人生有很多眼泪冲不掉的悲伤，所以真正坚强的人，都是越想哭反而笑得越大声，怀着痛楚和悲伤，带笑前行。',
    origin: '空知英秋《银魂》',
  },
  {
    dictum:
      '一路走来，各种坎坷，各种不顺和阻碍，终于我也看到了花团锦簇，也看到了灯彩佳话。那一夜我也曾梦见百万雄兵。',
    origin: '郭德纲',
  },
  {
    dictum:
      '“难道太阳出来了，你就不相信月亮了？月亮出来了，你就不相信太阳了吗？”，不管你有多少怀疑，爱就在心里，从未离开。',
  },
  {
    dictum:
      '怀中有残酒，腰间戴刀剑，四海为我家，心更在天涯尽头。 路见不平，拔刀相助。 冲天的意气只为一句然诺，这种人叫侠客。',
    origin: '裟椤双树《百妖谱》',
  },
  {
    dictum:
      '人不能两次踏入同一条河流，所以我们只能去寻找，寻找作为自己活着的道路，不管多少次，都要去寻找，对我们而言，这才刚开始啊',
    origin: '莓《DARLING in the FRANXX》',
  },
  {
    dictum:
      '去交会让你开心的朋友，去爱不会让你流泪的人，去向自己想去的方向，去完成不论大小的梦想，生活应该是美好而又温柔的，你也是。',
    origin: '《网易云热评》',
  },
  {
    dictum:
      '大家互相帮助，一起成功，一起幸福什么的，不过是种理想。 现实中，有人幸福，就必定有人被抛弃 有人光鲜，就必须有人满身泥泞。',
    origin: '大老师《我的青春恋爱物语果然有问题》',
  },
  {
    dictum:
      '这世上真正的好人和坏人都很少，大部分都是普通人。平时随波逐流，关键时刻则会出于自我保护 而露出獠牙――然而正是因为这样才可怕。',
    origin: '大老师《我的青春恋爱物语果然有问题》',
  },
  {
    dictum:
      '信仰到底是什么呢，就是纵身一跃，就是我们跟神之间一个永远的约定，是舍弃旧的去开始新的生活；信仰就是从今以后，再也不要放开你的手。',
    origin: '宫崎骏《悬崖上的金鱼姬》',
  },
  {
    dictum:
      '“我也能像你这样生活下去吗？” “那不是理所当然的吗？既然你知道不被人理解的痛苦，一定会比别人变得更加善良，一定能成为别人的支撑”',
    origin: '牧之原翔子《青春猪头少年不会梦到兔女郎学姐》',
  },
  {
    dictum:
      '飘飘荡荡的幻影，背负著可悲的宿命，在迷途中徘徊。 无解的恨与被恨，在破碎的镜子结合之时， 从时空交错的黑暗而来，为你洗刷无法昭雪的怨恨。',
    origin: '《地狱少女》',
  },
  {
    dictum:
      '据说是叫比翼之鸟，那种鸟只有一边的翅膀，雌雄一堆，相互依偎，能比其他人飞得更远，如果我能成为你的翅膀，就算会耗尽生命，我也会在这里，陪在你身边',
    origin: '广《DARLING in the FRANXX》',
  },
  {
    dictum:
      '02：还记得吗，我和达令很久以前也起誓结婚呢 广：当然 02：结婚就是和最重要的的人一直在一起的誓言，你是这样告诉我的，这个时候，你就变成了我的达令',
    origin: '《DARLING in the FRANXX》',
  },
  {
    dictum:
      '对你的喜欢，大抵是燃烧的星星坠落在海底开成珊瑚，又或是揉碎的白云环绕着山峦流成大河。那种梦幻，不真切，却令人迷醉的心动，就像晚风拥抱月亮，海浪亲吻礁石。',
    origin: '王牧',
  },
  {
    dictum:
      '我讨厌温柔的女孩子。温柔的女孩子其实对所有人都温柔，我却会误以为只对我温柔， 然后就沾沾自喜得意忘形，最后闹得不欢而散，双方都受到伤害。――所以我才讨厌温柔的女孩子。',
    origin: '大老师《我的青春恋爱物语果然有问题》',
  },
  {
    dictum:
      '许多人所谓的成熟，不过是被习俗磨去了棱角，变得世故而实际了。那不是成熟，而是精神的早衰和个性的消亡。真正的成熟，应当是独特个性的形成，真实自我的发现，精神上的结果和丰收。',
    origin: '周国平《灵魂只能独行》',
  },
  {
    dictum:
      '大家用奇怪的眼光看着你，把你当成笑柄，为什么就不在乎呢？ “我又不是为了被全人类喜爱而出生的” “我只要有一个人喜欢我就够了” “就算全世界都嫌弃我，只要那个人需要我，我就能活下去',
    origin: '《青春猪头少年不会梦到兔女郎学姐》',
  },
  {
    dictum:
      '等到高考那天你就会发现，考场周围几公里的工地停工了，市区的汽车不鸣笛了，所有的出租这都贴上了考生免费的标志，公交车也免费了，考场门口的矿泉水也是免费领，全世界都在为了你努力，所以请千万不要放弃你自己。',
  },
  {
    dictum:
      '喜欢上一个人，然后告白，两人相结合，所有人都说这是非常美妙的事情。但这确是大大的错误，恋人之间也存在着明确的权力关系。剥削与被剥削，付出与被付出，赢家与输家。如果您想高贵的活着，那么绝对不能成为输家。恋爱即战争！！',
    origin: '《辉夜大小姐想让我告白》',
  },
];

export const dictums3: dictumsType = [
  {
    dictum: '初为女友，请多关照。',
  },
  {
    dictum: '小手牵牵，岁岁年年。',
  },
  {
    dictum: '爱自己是终身浪漫的开始',
    origin: '王尔德',
  },
  {
    dictum: '山中若有眠，枕的是月。',
    origin: '简祯',
  },
  {
    dictum: '去没人的岛，摸鲨鱼的角',
    origin: '《Salt》',
  },
  {
    dictum: '我们风雨兼程绝不空手而归',
  },
  {
    dictum: '南风知我意，吹梦到西洲。',
    origin: '佚名《西洲曲》',
  },
  {
    dictum: '你一定要走，走到灯火通明。',
    origin: '卢思浩',
  },
  {
    dictum: '爱意时刻减淡，玫瑰不再浪漫',
  },
  {
    dictum: '做一阵风吧，有温柔也有英勇。',
  },
  {
    dictum: '海风吹不散玫瑰 月色难逃皎皎',
  },
  {
    dictum: '等待心动讯号，带你浪漫出逃。',
  },
  {
    dictum: '落俗不可避免，浪漫至死不渝。',
  },
  {
    dictum: '“这次爱与被爱同时发生了.”',
  },
  {
    dictum: '与其说你美好，不如说你不可重复。',
    origin: '约瑟夫・布罗茨基',
  },
  {
    dictum: '错过了落日余晖，可以期待满天繁星',
  },
  {
    dictum: '玲珑骰子安红豆，入骨相思知不知。',
    origin: '温庭筠《新添声杨柳枝词其二》',
  },
  {
    dictum: '告诉桃花不用开了，我等的人他来了。',
  },
  {
    dictum: '玫瑰花从来不会打折，浪漫从不廉价。',
    origin: 'Ustinian.《原创》',
  },
  {
    dictum: '当我凝望你眼眸，爱意撒满整个宇宙。',
    origin: '温和治疗《我想了太多关于你的形容》',
  },
  {
    dictum: '我们逃走吧，日暮，银河，别在梦里。',
  },
  {
    dictum: '山野千里，你是我藏在星星里的浪漫。',
  },
  {
    dictum: '半路下车的人很多，你不必耿耿于怀。',
  },
  {
    dictum: '在我荒瘠的土地上，你是最后的玫瑰。',
    origin: '聂鲁达《二十首情诗与绝望的歌》',
  },
  {
    dictum: '不知原谅什么， 诚觉世事尽可原谅。',
    origin: '木心',
  },
  {
    dictum: '你是年少的欢喜，这句话反过来也是你。',
    origin: '《最好的我们》',
  },
  {
    dictum: '你是我一时的冲动，也是我良久的喜欢。',
    origin: '《最撩人的情话是什么》',
  },
  {
    dictum: '此情无计可消除，才下眉头，却上心头。',
    origin: '李清照《一剪梅·红藕香残玉簟秋》',
  },
  {
    dictum: '你是我绕过山河错落，才找到的人间烟火。',
  },
  {
    dictum: '每朵云都下落不明，每盏月亮都不知所踪。',
    origin: '八月长安《暗恋》',
  },
  {
    dictum: '我拼命追赶那道光，因为光的尽头有你在。',
    origin: '新海诚《天气之子》',
  },
  {
    dictum: '活在这珍贵的人间，太阳强烈，水波温柔。',
    origin: '海子',
  },
  {
    dictum: '“无法阻止自己落俗，但浪漫至死不渝.”',
    origin: 'Aurora',
  },
  {
    dictum: '我当然不会试图摘月，我要月亮奔我而来。',
    origin: '奥黛丽・赫本',
  },
  {
    dictum: '一定要爱着点什么，恰似草木对光阴的钟情。',
    origin: '汪曾祺《人间草木》',
  },
  {
    dictum: '世间万物皆苦，你明目张胆的偏爱就是救赎。',
  },
  {
    dictum: '相思是冗长的腹稿，可表达出来却往往很短。',
  },
  {
    dictum: '“我将玫瑰藏于身后，时刻期盼着与你赴约”',
  },
  {
    dictum: '山河远阔，人间烟火，无一是你，无一不是你。',
    origin: '春和《江海共余生》',
  },
  {
    dictum: '你是我的，半截的诗，不允许别人更改一个字。',
    origin: '海子',
  },
  {
    dictum: '总有一天，宇宙变成一个点，你和我都在里面。',
    origin: '刘慈欣',
  },
  {
    dictum: '我在人间贩卖黄昏，只为收集世间美好奔向你。',
  },
  {
    dictum: '星星应该哈哈大笑，反正宇宙是个偏僻的地方。',
    origin: '鲍里斯・帕斯捷尔纳克',
  },
  {
    dictum: '我不要你风生虎啸， 我愿你老来无事饱加餐。',
    origin: '梁实秋《我把活着欢喜过了》',
  },
  {
    dictum: '“寒来暑往，秋收冬藏，你我也要来日方长。”',
  },
  {
    dictum: '山月孤寂，只是未见我。星河黯淡，只是未见你。',
    origin: '德卡先生的信箱',
  },
  {
    dictum: '人生下来不是为了拖着锁链，而是为了展开双翼。',
    origin: '雨果',
  },
  {
    dictum: '当你刚刚迈步离我远去，我便慌忙计算起你的归期。',
    origin: '珍黛妮·沙阿《我刚刚笑着同你道别》',
  },
  {
    dictum: '钟于一个人 忠于一个人 衷于一个人 终于一个人',
  },
  {
    dictum: '答案很长，我准备用一生来回答，你准备要听了吗？',
    origin: '林徽因',
  },
  {
    dictum: '晚霞与鲜花共绘浪漫，你是我藏在心里的爱意泛滥。',
  },
  {
    dictum: '“造物主自玫瑰诞生起便策划了这场名为救赎的邂逅”',
    origin: 'Aurora',
  },
  {
    dictum: '你既可以爱，又可以被爱，这是世界上最美好的事情。',
    origin: '王小波',
  },
  {
    dictum: '我们先养成活在世上的习惯，然后才学会思考的习惯。',
    origin: '加缪',
  },
  {
    dictum: '你不是暗淡渺小的星光，而是囊括了明月的整个银河。',
  },
  {
    dictum: '你的眼睛是银河不落星系， 你的呼吸仿佛是海浪风起。',
    origin: '阿尔达克',
  },
  {
    dictum: '我听见玫瑰低语，于是我把它夹在日记本里拥有了浪漫。',
    origin: '焦糖熊姬《焦糖熊姬》',
  },
  {
    dictum: '落日归山海，山海藏深意。 余晖伴晚霞，晚霞知我心。',
  },
  {
    dictum: '月亮失了约，太阳落了山，早知惊鸿一场，何必情深一往。',
  },
  {
    dictum: '你别赤脚在这草地上散步，我的花园到处都是星星的碎片。',
    origin: '伊迪特・索德格朗',
  },
  {
    dictum: '你瞧，世界上就是有一千个我，这一千个我总还是抱着你。',
    origin: '金庸',
  },
  {
    dictum: '不必行色匆匆，不必光芒四射，不必成为别人，只需做自己。',
    origin: '伍尔夫',
  },
  {
    dictum: '“迷失在莎士比亚的花园，那里盛放着浪漫主义者的玫瑰。”',
  },
  {
    dictum: '当我跨过沉沦的一切，向着永恒开战的时候，你就是我的军旗。',
    origin: '王小波《爱你就像爱生命》',
  },
  {
    dictum: '喜欢海，喜欢花，喜欢日出和日落，浪漫的年纪别活的太无趣。',
  },
  {
    dictum: '我这一生都是坚定不移的唯物主义者，唯有你，我希望有来生。',
    origin: '周总理',
  },
  {
    dictum: '无论何人无论何时，人们总要在乌云周围寻索着浪漫的微光活下去。',
    origin: '村上春树',
  },
  {
    dictum: '梦想，可以天花乱坠，理想，是我们一步一个脚印踩出来的坎坷道路。',
    origin: '三毛《亲爱的三毛》',
  },
  {
    dictum: '有一天，你那不可思议的甜笑，穿过闲谈的缝隙，摇醒了我昏眠的青春。',
    origin: '泰戈尔《泰戈尔诗选》',
  },
  {
    dictum: '也许世界上也有五千多和你一模一样的花，但只有你是我独一无二的玫瑰。',
    origin: '《小王子》',
  },
  {
    dictum: '我有点疲倦了，但我总要还有勇气，在狗一样的生活上做出神仙一样的事。',
    origin: '汪曾祺',
  },
  {
    dictum: '“落日余晖的路上总是爱意弥漫，我把墙砌的很高，唯独给你留了条小路。”',
  },
  {
    dictum: '醒来万物皆是沉寂，唯有你是世间的一抹旖旎，他人困于山中晨雾，我困于你。',
    origin: '德卡先生的信箱',
  },
  {
    dictum: '只有在星罗棋布的简陋屋子那边的大海，才是世界上躁动不安、永无宁日的见证。',
    origin: '阿尔贝·加缪《鼠疫》',
  },
  {
    dictum: '他的脸红不是因为亚热带的气候，而是因为那天太阳不忠，出卖一九九四年夏末心动。',
    origin: '温特梅《太平山顶》',
  },
  {
    dictum: '做一个真诚的人，不放弃对生活的热爱和执着，在有限的时间里，过无限广大的日子。',
    origin: '三毛',
  },
  {
    dictum: '浪漫，就是浪费时间慢慢吃饭，浪费时间慢慢喝茶，浪费时间慢慢走，浪费时间慢慢变老。',
    origin: '林清玄',
  },
  {
    dictum: '心之如何，有似万丈迷津，遥亘千里，其中并无舟子可以渡人，除了自渡，他人爱莫能助。',
    origin: '三毛',
  },
  {
    dictum: '生的终止不过一场死亡，死的意义不过在于重生或永眠，死亡不是失去生命，而是走出时间。',
    origin: '余华《活着》',
  },
  {
    dictum: '人有种奇怪的虚荣心，想让别人或自己相信他向往的是真理，但其实他有求于这个世间的是爱。',
    origin: '阿尔贝·加缪《加缪手记》',
  },
  {
    dictum:
      '你为什么那么喜欢落日？因为它像极了我喜欢你的心，就算会一点一点沉下去，明天照样会升起。',
    origin: '《德卡先生的信箱》',
  },
  {
    dictum:
      '跟你在一起的时光都很耀眼，因为天气好，因为天气不好，因为天气刚刚好，每一天，都很美好。',
    origin: '《孤单又灿烂的神-鬼怪》',
  },
  {
    dictum:
      '我本想去地狱，可是地狱打烊便转身走去天堂，但天堂也客满，于是我路过人间，正好你房间正通亮。',
    origin: '《网易云热评》',
  },
  {
    dictum: '我们把在黑暗中跳舞的心脏 叫做月亮 而你 是云层里 隐约可见的星光 是银河里掉下来的一颗糖',
  },
  {
    dictum:
      '你的眼睛真好看，里面有晴雨，日月，山川，江河，云雾，花鸟，但我的眼睛更好看，因为我的眼里有你。',
    origin: '余光中',
  },
  {
    dictum:
      '我那里会浪漫啊，浪漫的是日出，是晚霞；浪漫的是路过的行人，是路边的鲜花；浪漫的是世间万物，是我们。',
    origin: '玖辞《记事录》',
  },
  {
    dictum:
      '我用什么才能留住你，我给你瘦落的街道，绝望的落日，荒郊的月亮，我给你一个久久地望着孤月的人的悲哀。',
    origin: '博尔赫斯《我用什么才能留住你》',
  },
  {
    dictum:
      '不要走在我后面，因为我可能不会引路；不要走在我前面，因为我可能不会跟随；请走在我的身边，做我的朋友。',
    origin: '阿尔贝・加缪',
  },
  {
    dictum:
      '我把我整个灵魂都给你，连同它的怪癖，耍小脾气，忽明忽暗，一千八百种坏毛病。它真讨厌，只有一点好，爱你。',
    origin: '王小波《爱你就像爱生命》',
  },
  {
    dictum:
      '我会住在其中的一颗星星上面,在某一颗星星上微笑着，每当夜晚你仰望星空的时候，就会像是看到所有的星星都在微笑一般。',
    origin: '《小王子》',
  },
  {
    dictum:
      '着迷于你眼睛，银河有迹可循，穿过时间的缝隙，它依然真实地，吸引我轨迹。等到看你银色满际，等到分不清季节更替，才敢说沉溺。',
    origin: '《水星记》',
  },
  {
    dictum:
      '年轻时，我会向众生需索他们能力范围之外的：友谊长存，热情不减。如今，我明白只能要求对方能力范围之内的：陪伴就好，不用说话。',
    origin: '阿尔贝・加缪《卡缪札记》',
  },
  {
    dictum:
      '对于某人来说，你就是宇宙的中心——就像小麦哲伦星云一样，你散发着整个宇宙的光芒，帮助他们找到方向。虽然你可能并没有意识到。',
  },
  {
    dictum:
      '一旦喜欢上谁就别无所求，只要每天能见到他就已经觉得很庆幸，一辈子很短，如白驹过隙，转瞬即逝。可这种心情很长，如高山大川，绵延不绝。',
    origin: '《武林外传》',
  },
  {
    dictum:
      'NGC2237号玫瑰星云 这朵世间最好的玫瑰 星尘为泥 银河滋养。 永远不会枯萎，永远在沉静宇宙中盛，这是我要给你的 宇宙级别的浪漫。',
    origin: '稚楚《我只喜欢你的人设》',
  },
  {
    dictum: 'There is not love of life without despair about life. 没有对生活绝望，就不会爱生活。',
    origin: '阿尔贝·加缪《局外人》',
  },
  {
    dictum:
      '前行的路上，我们不仅受远方的羁绊，还被行人影响，你想要成为什么样的人，就去接近那样的人。宇宙除了爆炸后形成了银河系，它还给了相同磁场的人，同样的运气。',
    origin: '张皓宸',
  },
  {
    dictum:
      '对你的喜欢，大抵是燃烧的星星坠落在海底开成珊瑚，又或是揉碎的白云环绕着山峦流成大河。那种梦幻，不真切，却令人迷醉的心动，就像晚风拥抱月亮，海浪亲吻礁石。',
    origin: '王牧',
  },
  {
    dictum:
      'Thousands of miles in the mountains, you are my romance hidden in the stars. 山野千里，你是我藏在星星里的浪漫。',
  },
  {
    dictum:
      '我天性不宜交际。在多数场合，我不是觉得对方乏味，就是害怕对方觉得我乏味。可是我既不愿忍受对方的乏味，也不愿费劲使自己显得有趣，那都太累了。我独处时最轻松，因为我不觉得自己乏味，即使乏味，也自己承受，不累及他人，无需感到不安。',
    origin: '周国平《风中的纸屑》',
  },
]
  .filter((value, index, self) => self.indexOf(value) === index)
  .sort((a, b) => a.dictum?.length - b.dictum?.length);

const dictumsArr = [
  {
    novel: '剑来',
    dictums: jianlaiDictums,
  },
  {
    novel: '雪中悍刀行',
    dictums: xuezhongDictums,
  },
  {
    novel: '动漫',
    dictums: dictums2,
  },
  {
    novel: '哲学',
    dictums: dictums3,
  },
]

export { dictumsArr }